import TableBody from '@mui/material/TableBody';

export { TableBody };
